import { render } from "./IconChevronDown.vue?vue&type=template&id=e3a2f270&ts=true"
import script from "./IconChevronDown.vue?vue&type=script&lang=ts"
export * from "./IconChevronDown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__